import { create } from 'zustand'
import type { Stats } from '../types/stats'
import { StatsService } from '../services/api/statsService'

interface StatsState {
  stats: Stats | null
  isLoading: boolean
  error: string | null
  fetchStats: () => Promise<void>
  setStats: (stats: Stats) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
}

export const useStatsStore = create<StatsState>()((set) => ({
  stats: null,
  isLoading: false,
  error: null,

  setStats: (stats: Stats) => {
    set({ stats })
  },

  setLoading: (loading: boolean) => {
    set({ isLoading: loading })
  },

  setError: (error: string | null) => {
    set({ error })
  },

  fetchStats: async () => {
    set({ isLoading: true, error: null })
    
    try {
      const stats = await StatsService.getStats()
      set({ stats, isLoading: false, error: null })
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Erreur lors du chargement des statistiques'
      set({ isLoading: false, error: errorMessage })
    }
  },
}))